import type { IUpdateProfileParams } from '@/interfaces/api/user'
import type { IUserLight } from '@/interfaces/entities/user'

export function buildCompanyUserUpdatePayload(user: IUserLight): IUpdateProfileParams {
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    role: user.role,
    shift_id: user.shift_id ?? user.shift?.id ?? null,
    phone_number: user.phone_number,
    receive_alerts: user.receive_alerts,
    receive_push: user.receive_push,
    receive_email: user.receive_email,
    receive_whatsapp: user.receive_whatsapp,
  }
}

export function patchUserLightFromPayload(prev: IUserLight, p: IUpdateProfileParams): IUserLight {
  return {
    ...prev,
    name: p.name,
    email: p.email,
    ...(p.role !== undefined ? { role: p.role } : {}),
    ...(p.shift_id !== undefined ? { shift_id: p.shift_id } : {}),
    ...(p.phone_number !== undefined ? { phone_number: p.phone_number } : {}),
    ...(p.receive_alerts !== undefined ? { receive_alerts: p.receive_alerts } : {}),
    ...(p.receive_push !== undefined ? { receive_push: p.receive_push } : {}),
    ...(p.receive_email !== undefined ? { receive_email: p.receive_email } : {}),
    ...(p.receive_whatsapp !== undefined ? { receive_whatsapp: p.receive_whatsapp } : {}),
  }
}
